import { toast } from 'sonner';

import { Check, X } from 'lucide-react';

import { Button } from '@web/components/ui/button';

export const toastConfirm = ({
  message,
  callback,
}: {
  message: string;
  callback: () => void;
}) => {
  const toastId = toast.warning(message, {
    action: (
      <Button
        variant="ghost"
        size="icon"
        className="hover:bg-primary/20 size-6 rounded-full"
        onClick={() => {
          callback();
          toast.dismiss(toastId);
        }}
      >
        <Check className="stroke-primary size-4" />
      </Button>
    ),

    cancel: (
      <Button
        variant="ghost"
        size="icon"
        className="hover:bg-destructive/20 size-6 rounded-full"
        onClick={() => {
          toast.dismiss(toastId);
        }}
      >
        <X className="stroke-destructive size-4" />
      </Button>
    ),
  });
};
